<script setup lang="ts">
  defineOptions({ name: 'CPPortalBrandHomeLink' })

  import type { PropType } from 'vue'

  import CPAvatar from '@ui/components/CPAvatar.vue'
  import CPButton from '@ui/components/CPButton.vue'
  import CPText from '@ui/components/CPText.vue'

  import { createElementId } from '@common/core-layer/utils'

  defineProps({
    portalIcon: {
      type: String as PropType<string | null>,
      default: null,
    },
    portalName: {
      type: String,
      required: true,
    },
    portalSubtitle: {
      type: String as PropType<string | null>,
      default: null,
    },
  })

  const emit = defineEmits<{
    click: []
  }>()
</script>

<template>
  <CPButton
    :id="createElementId('portal-brand', 'home', 'link')"
    type="ghost"
    class="!h-12 !w-full !min-w-0 !justify-start !gap-2 !rounded-md !px-2 !py-2 hover:!bg-sidebar-hover"
    @click="emit('click')"
  >
    <CPAvatar v-if="portalIcon" :src="portalIcon" :alt="portalName" :title="portalName" shape="square" size="sm" class="flex-shrink-0" />
    <div class="grid min-w-0 flex-1 text-left ml-2">
      <CPText size="lg" weight="medium" htmlTag="span" class="truncate !leading-tight">
        {{ portalName }}
      </CPText>
      <CPText v-if="portalSubtitle" size="sm" htmlTag="span" class="text-600 truncate !leading-tight">
        {{ portalSubtitle }}
      </CPText>
    </div>
  </CPButton>
</template>
